import { SaleSelectableEntitiesResponseDto } from "@/lib/interfaces/sales";
import DataFetchParent from "@/ui-components/ui/data-fetch";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SalesFetcher from "./fetcher";
import SalesFilters from "./sales-filters";

const Sales = () => {
  const [reload, setReload] = useState(false);
  const [searchParams] = useSearchParams();
  const [searchQuery] = useState(searchParams.toString() || `page=1`);
  const [filters, setFilters] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const [selectableEntities, setSelectableEntities] = useState<SaleSelectableEntitiesResponseDto>();

  useEffect(() => {
    if (selectableEntities) {
      setIsLoading(false);
    }
  }, [selectableEntities]);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Verkaufsberichte</PageTitle>
          <DataFetchParent
            isLoading={isLoading}
            data={selectableEntities}
            renderElement={(items) => <SalesFilters setFilters={setFilters} selectableEntities={items} />}
          />
        </div>
      </PageTitleContainer>
      <SalesFetcher
        searchQuery={searchQuery}
        setReload={setReload}
        reload={reload}
        filters={filters}
        setSelectableEntities={setSelectableEntities}
      />
    </div>
  );
};

export default Sales;
